import React from 'react'

function Store() {
  return (
    <svg width={82} height={82} viewBox="0 0 82 82" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.083 20.5h47.834a3.427 3.427 0 003.416-3.417 3.427 3.427 0 00-3.416-3.417H17.083a3.427 3.427 0 00-3.416 3.417 3.427 3.427 0 003.416 3.416zm51.797 6.15c-.307-1.572-1.708-2.734-3.348-2.734H16.468c-1.64 0-3.04 1.162-3.348 2.733L9.703 43.733c-.41 2.118 1.196 4.1 3.349 4.1h.615v17.083a3.427 3.427 0 003.416 3.417h27.334a3.427 3.427 0 003.416-3.417V47.833H61.5v17.083a3.427 3.427 0 003.417 3.417 3.427 3.427 0 003.416-3.417V47.833h.615c2.153 0 3.759-1.982 3.349-4.1L68.88 26.649zM20.5 61.5H41V47.832H20.5v13.666z"
        fill="#fff"
        opacity={0.1}
      />
    </svg>
  )
}

export default React.memo(Store)
